'use strict';

/* ═══════════════════════════════════════════════════════
   DESIGN PATHS  (embedded from recipe1.svg, 800×800)
   Design decorative elements span approx y=265–580
   ═══════════════════════════════════════════════════════ */
/* DESIGN PATHS LOADED FROM recipe-designs.js */
/* Replace the <script src> tag below with your Shopify asset URL */


/* ═══════════════════════════════════════════════════════
   STATE
   ═══════════════════════════════════════════════════════ */
let sourceImg  = null;
let rasterData = null;
let activeTab  = 'original';
let debTimer   = null;

/* Eraser state */
let eraserOn      = false;
let eraserSize    = 16;      // brush radius in rasterData pixels
let eraseHistory  = [];      // stack of Float32Array snapshots for undo
let isErasing     = false;

const $ = id => document.getElementById(id);
const canvas = $('displayCanvas');
const ctx    = canvas.getContext('2d');
const cursorC = $('cursorCanvas');
const cursorX = cursorC.getContext('2d');

/* ═══════════════════════════════════════════════════════
   UPLOAD
   ═══════════════════════════════════════════════════════ */
$('uploadZone').addEventListener('click', () => $('fileInput').click());
$('uploadZone').addEventListener('dragover', e => { e.preventDefault(); $('uploadZone').classList.add('drag-over'); });
$('uploadZone').addEventListener('dragleave', () => $('uploadZone').classList.remove('drag-over'));
$('uploadZone').addEventListener('drop', e => {
  e.preventDefault(); $('uploadZone').classList.remove('drag-over');
  if (e.dataTransfer.files[0]) handleFile(e.dataTransfer.files[0]);
});
$('fileInput').addEventListener('change', () => { if ($('fileInput').files[0]) handleFile($('fileInput').files[0]); });

function handleFile(file) {
  if (!/image\/(jpeg|jpg|png|webp)/i.test(file.type) && !/\.(jpe?g|png|webp)$/i.test(file.name)) {
    setStatus('err', '✗ Please upload a JPG, PNG, or WEBP image'); return;
  }
  const reader = new FileReader();
  reader.onload = e => {
    const img = new Image();
    img.onload = () => {
      sourceImg = img;
      $('uzInner').innerHTML = `<img class="uz-thumb" src="${e.target.result}"><div class="uz-fname">${file.name}</div><div class="uz-change">Click to change</div>`;
      setStatus('ok', '✓ Photo loaded — processing…');
      $('tabPreview').disabled = false;
      $('btnReset').disabled   = false;
      $('tabDesign').disabled  = false;
      scheduleProcess();
    };
    img.onerror = () => setStatus('err', '✗ Could not read the image file');
    img.src = e.target.result;
  };
  reader.readAsDataURL(file);
}
function setStatus(type, msg) {
  const el = $('statusStrip');
  el.className = 'status-strip ' + type; el.textContent = msg;
}

/* ═══════════════════════════════════════════════════════
   WIDTH STEPPER
   ═══════════════════════════════════════════════════════ */


/* ═══════════════════════════════════════════════════════
   SLIDERS & TOGGLE
   ═══════════════════════════════════════════════════════ */
[['sCleanup','vCleanup'],['sContrast','vContrast'],['sThresh','vThresh'],['sSharpen','vSharpen']].forEach(([sid,vid]) => {
  $(sid).addEventListener('input', () => { $(vid).textContent = Math.round($(sid).value); if (sourceImg) scheduleProcess(); });
});
// tDesign toggle removed — design always shown on Add Design tab

/* Design picker — swap active design and redraw */
document.querySelectorAll('.design-pick').forEach(btn => {
  btn.addEventListener('click', () => {
    activeDesign = btn.dataset.design;
    document.querySelectorAll('.design-pick').forEach(b => b.classList.remove('active'));
    btn.classList.add('active');
    if (rasterData && activeTab === 'design') switchTab('design');
  });
});

// Design size & position sliders — redraw preview without reprocessing image
$('sDesignSize').addEventListener('input', () => {
  $('vDesignSize').textContent = Math.round($('sDesignSize').value) + '%';
  if (rasterData && activeTab === 'design') switchTab('design');
});
$('sDesignPos').addEventListener('input', () => {
  const v = parseInt($('sDesignPos').value);
  $('vDesignPos').textContent = (v > 0 ? '+' : '') + v + ' mm';
  if (rasterData && activeTab === 'design') switchTab('design');
});

/* ═══════════════════════════════════════════════════════
   ERASER
   ─────────────────────────────────────────────────────
   Erasing works directly on rasterData.gray (the full-
   resolution Float32Array). The canvas is just scaled
   for display, so we map canvas pixels → data pixels
   using the current css-to-data scale ratio.
   ═══════════════════════════════════════════════════════ */

/* ═══════════════════════════════════════════════════════
   ERASER
   ─────────────────────────────────────────────────────
   All coordinates are in canvas CSS pixel space.
   canvasToPx maps from CSS coords → data pixel coords.
   The cursor overlay (cursorC) floats above displayCanvas
   and shows the eraser circle in real time.
   ═══════════════════════════════════════════════════════ */

function updateEraserUI() {
  $('btnEraser').classList.toggle('active', eraserOn);
  if (!eraserOn) hideCursor();
}

function syncCursorCanvas() {
  // Make cursor canvas exactly overlay the display canvas
  const rect = canvas.getBoundingClientRect();
  const pRect = canvas.parentElement.getBoundingClientRect();
  cursorC.width  = canvas.width;
  cursorC.height = canvas.height;
  cursorC.style.width   = (canvas.style.width  || canvas.width  + 'px');
  cursorC.style.height  = (canvas.style.height || canvas.height + 'px');
  cursorC.style.left    = (rect.left - pRect.left) + 'px';
  cursorC.style.top     = (rect.top  - pRect.top)  + 'px';
}

function showCursorAt(csx, csy) {
  // csx/csy are canvas-pixel coords (0..canvas.width)
  cursorC.style.display = 'block';
  syncCursorCanvas();
  cursorX.clearRect(0, 0, cursorC.width, cursorC.height);
  // Brush radius in canvas pixels
  const r = eraserSize / 2;
  cursorX.beginPath();
  cursorX.arc(csx, csy, r, 0, Math.PI*2);
  cursorX.strokeStyle = 'rgba(220,40,40,0.9)';
  cursorX.lineWidth = 1.5;  // constant — same outline at any brush size
  cursorX.stroke();
  // White fill so you can see it on dark ink
  cursorX.fillStyle = 'rgba(255,255,255,0.18)';
  cursorX.fill();
}

function hideCursor() {
  cursorC.style.display = 'none';
  cursorX.clearRect(0, 0, cursorC.width, cursorC.height);
}

// Map from CSS pointer coords → canvas pixel coords
function cssToPx(e) {
  const rect = canvas.getBoundingClientRect();
  const src  = e.touches ? e.touches[0] : e;
  const scaleX = canvas.width  / rect.width;
  const scaleY = canvas.height / rect.height;
  return [(src.clientX - rect.left) * scaleX,
          (src.clientY - rect.top)  * scaleY];
}

// Map canvas pixel coords → rasterData pixel coords
function pxToData(cx, cy) {
  const sx = rasterData.w / canvas.width;
  const sy = rasterData.h / canvas.height;
  return [Math.round(cx * sx), Math.round(cy * sy)];
}

function eraseAt(csx, csy) {
  if (!rasterData || !eraserOn || activeTab !== 'preview') return;
  const [dx, dy] = pxToData(csx, csy);
  const rData = Math.round(eraserSize / 2 * rasterData.w / canvas.width);
  const r2 = rData * rData;
  const { gray, w, h } = rasterData;
  const x0 = Math.max(0, dx - rData), x1 = Math.min(w-1, dx + rData);
  const y0 = Math.max(0, dy - rData), y1 = Math.min(h-1, dy + rData);
  for (let py = y0; py <= y1; py++)
    for (let px = x0; px <= x1; px++)
      if ((px-dx)**2 + (py-dy)**2 <= r2) gray[py*w+px] = 1.0;
  // Repaint the whole canvas from the updated data
  const id = ctx.createImageData(w, h);
  for (let i = 0; i < w*h; i++) {
    const v = Math.round(gray[i]*255);
    id.data[i*4]=id.data[i*4+1]=id.data[i*4+2]=v; id.data[i*4+3]=255;
  }
  ctx.putImageData(id, 0, 0);
  showCursorAt(csx, csy);
}

$('btnEraser').addEventListener('click', () => {
  eraserOn = !eraserOn;
  updateEraserUI();
});

document.querySelectorAll('.esz-btn').forEach(btn => {
  btn.addEventListener('click', () => {
    eraserSize = parseInt(btn.dataset.size);
    document.querySelectorAll('.esz-btn').forEach(b => b.classList.remove('active'));
    btn.classList.add('active');
  });
});

$('btnUndoErase').addEventListener('click', () => {
  if (!eraseHistory.length) return;
  rasterData.gray = eraseHistory.pop();
  $('btnUndoErase').disabled  = eraseHistory.length === 0;
  $('btnResetErase').disabled = eraseHistory.length === 0;
  drawPreview();
});

$('btnResetErase').addEventListener('click', () => {
  if (!eraseHistory.length) return;
  rasterData.gray = eraseHistory[0];
  eraseHistory = [];
  $('btnUndoErase').disabled = true;
  $('btnResetErase').disabled = true;
  drawPreview();
});

canvas.addEventListener('mouseenter', e => {
  if (eraserOn && activeTab === 'preview') {
    const [x,y] = cssToPx(e); showCursorAt(x,y);
  }
});
canvas.addEventListener('mouseleave', () => { isErasing = false; hideCursor(); });

canvas.addEventListener('mousemove', e => {
  if (activeTab !== 'preview') return;
  const [x,y] = cssToPx(e);
  if (eraserOn) { showCursorAt(x,y); if (isErasing) eraseAt(x,y); }
});

canvas.addEventListener('mousedown', e => {
  if (!eraserOn || activeTab !== 'preview') return;
  eraseHistory.push(new Float32Array(rasterData.gray));
  if (eraseHistory.length > 40) eraseHistory.shift();
  $('btnUndoErase').disabled = false;
  $('btnResetErase').disabled = false;
  isErasing = true;
  const [x,y] = cssToPx(e); eraseAt(x,y);
});

canvas.addEventListener('mouseup', () => { isErasing = false; });

canvas.addEventListener('touchstart', e => {
  if (!eraserOn || activeTab !== 'preview') return;
  e.preventDefault();
  eraseHistory.push(new Float32Array(rasterData.gray));
  if (eraseHistory.length > 40) eraseHistory.shift();
  $('btnUndoErase').disabled = false;
  $('btnResetErase').disabled = false;
  isErasing = true;
  const [x,y] = cssToPx(e); eraseAt(x,y);
}, { passive: false });

canvas.addEventListener('touchmove', e => {
  if (!isErasing) return;
  e.preventDefault();
  const [x,y] = cssToPx(e); eraseAt(x,y);
}, { passive: false });

canvas.addEventListener('touchend', () => { isErasing = false; hideCursor(); });




/* ── Tab click listeners ─────────────────────────────── */
document.querySelectorAll('.p-tab').forEach(btn =>
  btn.addEventListener('click', () => { if (!btn.disabled) switchTab(btn.dataset.tab); })
);

function switchTab(tab) {
  activeTab = tab;
  document.querySelectorAll('.p-tab').forEach(b => b.classList.toggle('active', b.dataset.tab===tab));
  $('phBlock').style.display  = 'none';
  canvas.style.display        = 'none';
  $('eraserBar').style.display    = (tab==='preview' && rasterData) ? 'flex' : 'none';
  $('designPanel').style.display   = tab==='design' ? 'flex' : 'none';
  $('designBottom').style.display  = (tab==='design' && rasterData) ? 'flex' : 'none';
  if (tab !== 'preview') { eraserOn = false; isErasing = false; updateEraserUI(); hideCursor(); }

  if (tab === 'original') {
    if (!sourceImg)  { showPH(); return; }
    drawOriginal();
  } else if (tab === 'preview') {
    if (!rasterData) { showPH(); return; }
    drawPreview();
  } else {  // design — always show composite
    if (!rasterData) { showPH(); return; }
    drawComposite();
  }
}
function showPH() { $('phBlock').style.display = 'flex'; }

function drawOriginal() {
  canvas.style.display='block';
  const maxW=canvas.parentElement.clientWidth-30, maxH=460;
  const r=Math.min(maxW/sourceImg.width, maxH/sourceImg.height, 1);
  canvas.width=Math.round(sourceImg.width*r); canvas.height=Math.round(sourceImg.height*r);
  canvas.style.width=''; canvas.style.height='';
  ctx.drawImage(sourceImg, 0, 0, canvas.width, canvas.height);
  hideCursor();
}

function drawPreview() {
  const {gray,w,h}=rasterData;
  canvas.style.display='block';
  // Only reset canvas dimensions if they differ — resetting clears eraser work
  if (canvas.width !== w || canvas.height !== h) { canvas.width=w; canvas.height=h; }
  const id=ctx.createImageData(w,h);
  for (let i=0; i<w*h; i++) {
    const v=Math.round(gray[i]*255);
    id.data[i*4]=id.data[i*4+1]=id.data[i*4+2]=v; id.data[i*4+3]=255;
  }
  ctx.putImageData(id,0,0);
  const maxW=canvas.parentElement.clientWidth-30, maxH=460;
  const r=Math.min(maxW/w, maxH/h, 1);
  if (r<1) { canvas.style.width=Math.round(w*r)+'px'; canvas.style.height=Math.round(h*r)+'px'; }
  else { canvas.style.width=''; canvas.style.height=''; }
  // Sync cursor overlay dimensions to match
  syncCursorCanvas();
}

/* ── Composite preview (recipe + design) ──────────────────────────
   Build the SVG as a blob URL and draw it to canvas via drawImage.
   This exactly matches the downloaded SVG content.                  */
/* ── Design layout parameters ──────────────────────────────────────
   Single source of truth for size, position and total SVG height.
   sizePercent: 100 = design fills full output width.
   positionMM:  0 = default 18mm overlap; +ve = further down, -ve = up. */
function getDesignParams(physW, physH) {
  const sizePercent = parseFloat($('sDesignSize').value);
  const positionMM  = parseFloat($('sDesignPos').value);
  const overlapMM   = 18;

  const designScale = (physW * sizePercent / 100) / 800;
  const designWidth = 800 * designScale;

  // Total canvas width: whichever is wider — recipe or design
  const totalW      = Math.max(physW, designWidth);
  // Recipe and design X offsets so both are horizontally centred in totalW
  const recipeOffsetX = (totalW - physW) / 2;
  const designX       = (totalW - designWidth) / 2;

  const designTY = physH - overlapMM - DESIGN_TOP * designScale + positionMM;
  const totalH   = Math.max(physH, designTY + DESIGN_BOTTOM * designScale);

  return { designScale, designX, designTY, totalW, totalH, recipeOffsetX };
}

/* ── Composite preview ─────────────────────────────────────────────
   Draws recipe raster + design paths via Path2D directly on canvas.
   No SVG image loading = no browser security blocks, instant render. */
function drawComposite() {
  if (!rasterData || !sourceImg) { showPH(); return; }
  canvas.style.display = 'block';

  const physW = 300;  // internal preview reference in mm
  const physH = Math.round(physW * sourceImg.height / sourceImg.width);
  const { designScale, designX, designTY, totalW, totalH, recipeOffsetX } = getDesignParams(physW, physH);

  // Fit to preview area
  const maxW = canvas.parentElement.clientWidth - 30, maxH = 460;
  const aspect = totalH / totalW;
  let cw = maxW, ch = Math.round(maxW * aspect);
  if (ch > maxH) { ch = maxH; cw = Math.round(maxH / aspect); }
  canvas.width = cw; canvas.height = ch;
  canvas.style.width = ''; canvas.style.height = '';

  const ppm = cw / totalW;  // pixels per mm (based on wider of recipe/design)

  ctx.fillStyle = 'white';
  ctx.fillRect(0, 0, cw, ch);

  // Recipe raster — centred within totalW
  const { gray, w, h } = rasterData;
  const tmp = mkCanvas(w, h);
  const txc = tmp.getContext('2d');
  const id  = txc.createImageData(w, h);
  for (let i = 0; i < w*h; i++) {
    const v = Math.round(gray[i]*255);
    id.data[i*4]=id.data[i*4+1]=id.data[i*4+2]=v; id.data[i*4+3]=255;
  }
  txc.putImageData(id, 0, 0);
  ctx.drawImage(tmp, Math.round(recipeOffsetX * ppm), 0, Math.round(physW * ppm), Math.round(physH * ppm));

  // Design paths — centred within totalW, no clipping at any size
  ctx.save();
  ctx.translate(designX * ppm, designTY * ppm);
  ctx.scale(designScale * ppm, designScale * ppm);
  ctx.fillStyle = 'black';
  for (const p of getDesignPaths()) ctx.fill(p);
  ctx.restore();
}

/* ═══════════════════════════════════════════════════════
   PROCESS SCHEDULING
   ═══════════════════════════════════════════════════════ */
function scheduleProcess() { clearTimeout(debTimer); debTimer = setTimeout(runProcess, 460); }

async function runProcess() {
  if (!sourceImg) return;
  setOverlay(true,'Processing image…','Cleaning and adjusting tone'); await tick();
  try {
    const s = readSettings();
    rasterData = computeRaster(sourceImg, s);
    eraseHistory = [];
    $('btnUndoErase').disabled = true;
    $('btnResetErase').disabled = true;
    $('btnJPG').disabled = false;
    $('tabDesign').disabled = false;
    $('btnSVGdesign').disabled = false;
    const hMM = Math.round(s.physW * sourceImg.height / sourceImg.width);
    $('ipSize').textContent = `${rasterData.w} × ${rasterData.h} px`;
    $('infoBar').classList.add('show');
    setStatus('ok','✓ Done — preview and download below');
    switchTab(activeTab==='original' ? 'preview' : activeTab);
  } catch(err) {
    console.error(err);
    setStatus('err','✗ Processing failed — try adjusting the settings');
  } finally { setOverlay(false); }
}

function readSettings() {
  return {
    cleanup:  parseInt($('sCleanup').value),
    contrast: parseInt($('sContrast').value),
    thresh:   parseInt($('sThresh').value),
    sharpen:  parseInt($('sSharpen').value),
  };
}
function setOverlay(on,msg,sub) {
  $('procOverlay').classList.toggle('on',on);
  if (msg!==undefined) $('procMsg').textContent=msg;
  if (sub!==undefined) $('procSub').textContent=sub;
}
function tick() { return new Promise(r=>setTimeout(r,16)); }

/* ═══════════════════════════════════════════════════════
   IMAGE PIPELINE
   ═══════════════════════════════════════════════════════ */
const JPEG_MAX = 4800;
const BG_MAX   = 350;

function computeRaster(img, s) {
  const ratio = Math.min(JPEG_MAX / img.width, JPEG_MAX / img.height, 1);
  const w = Math.round(img.width  * ratio);
  const h = Math.round(img.height * ratio);
  const oc = mkCanvas(w,h);
  oc.getContext('2d').drawImage(img, 0, 0, w, h);
  const raw = oc.getContext('2d').getImageData(0,0,w,h).data;
  let f = rgbToGray(raw, w, h);
  if (s.cleanup > 0) f = cleanBackground(f, w, h, s.cleanup);
  f = autoLevels(f, w, h);
  f = applyContrast(f, w, h, s.contrast / 100);

  // Threshold to binary (0 = ink, 1 = paper)
  const t = s.thresh / 255;
  const bin = new Float32Array(w * h);
  for (let i = 0; i < w*h; i++) bin[i] = f[i] < t ? 0.0 : 1.0;

  // Sharpen: reduce the anti-alias blur sigma.
  // The post-threshold gaussBlur is the only source of softness in the output.
  // At sharpen=0  → sigma=0.85 (soft, natural ink edge)
  // At sharpen=50 → sigma=0.40 (noticeably crisper)
  // At sharpen=100→ sigma=0.12 (near-hard binary, very crisp)
  const blurSigma = 0.85 * Math.pow(0.14, s.sharpen / 100);

  const out = gaussBlur(bin, w, h, blurSigma);
  return { gray: out, w, h };
}

function rgbToGray(data, w, h) {
  const f = new Float32Array(w*h);
  for (let i=0; i<w*h; i++)
    f[i] = (0.2126*data[i*4] + 0.7152*data[i*4+1] + 0.0722*data[i*4+2]) / 255;
  return f;
}

function gaussBlur(f, w, h, sigma) {
  const r=Math.max(1,Math.ceil(sigma*2.5));
  const kern=[]; let ks=0;
  for (let i=-r;i<=r;i++) { const k=Math.exp(-(i*i)/(2*sigma*sigma)); kern.push(k); ks+=k; }
  for (let i=0;i<kern.length;i++) kern[i]/=ks;
  const tmp=new Float32Array(w*h), out=new Float32Array(w*h);
  for (let y=0;y<h;y++) for (let x=0;x<w;x++) {
    let s=0; for (let k=0;k<kern.length;k++) s+=f[y*w+Math.max(0,Math.min(w-1,x+k-r))]*kern[k];
    tmp[y*w+x]=s;
  }
  for (let y=0;y<h;y++) for (let x=0;x<w;x++) {
    let s=0; for (let k=0;k<kern.length;k++) s+=tmp[Math.max(0,Math.min(h-1,y+k-r))*w+x]*kern[k];
    out[y*w+x]=s;
  }
  return out;
}

function cleanBackground(f, w, h, strength) {
  const bScale = Math.min(BG_MAX / w, BG_MAX / h, 1);
  const bw = Math.max(1, Math.round(w * bScale));
  const bh = Math.max(1, Math.round(h * bScale));
  const srcC = mkCanvas(w, h);
  const srcX = srcC.getContext('2d');
  const srcId = srcX.createImageData(w, h);
  for (let i=0; i<w*h; i++) {
    const v = Math.round(f[i]*255);
    srcId.data[i*4]=srcId.data[i*4+1]=srcId.data[i*4+2]=v; srcId.data[i*4+3]=255;
  }
  srcX.putImageData(srcId, 0, 0);
  const bgSmC = mkCanvas(bw, bh);
  const bgSmX = bgSmC.getContext('2d');
  bgSmX.imageSmoothingEnabled=true; bgSmX.imageSmoothingQuality='high';
  bgSmX.drawImage(srcC, 0, 0, bw, bh);
  const bgSmPix = bgSmX.getImageData(0, 0, bw, bh).data;
  const bgSm = new Float32Array(bw*bh);
  for (let i=0; i<bw*bh; i++) bgSm[i] = bgSmPix[i*4]/255;
  const sigma = Math.min(20 + strength*0.25, bw*0.45);
  const bgBlur = gaussBlur(bgSm, bw, bh, sigma);
  const bgBlurC = mkCanvas(bw, bh);
  const bgBlurX = bgBlurC.getContext('2d');
  const bgBlurId = bgBlurX.createImageData(bw, bh);
  for (let i=0; i<bw*bh; i++) {
    const v = Math.round(bgBlur[i]*255);
    bgBlurId.data[i*4]=bgBlurId.data[i*4+1]=bgBlurId.data[i*4+2]=v; bgBlurId.data[i*4+3]=255;
  }
  bgBlurX.putImageData(bgBlurId, 0, 0);
  const bgFullC = mkCanvas(w, h);
  const bgFullX = bgFullC.getContext('2d');
  bgFullX.imageSmoothingEnabled=true; bgFullX.imageSmoothingQuality='high';
  bgFullX.drawImage(bgBlurC, 0, 0, w, h);
  const bgFullPix = bgFullX.getImageData(0, 0, w, h).data;
  const t = strength / 100;
  const out = new Float32Array(w*h);
  for (let i=0; i<w*h; i++) {
    const bgv = Math.max(bgFullPix[i*4]/255, 0.08);
    const ratio = Math.min(f[i]/bgv, 1.0);
    out[i] = Math.max(0, Math.min(1, (1-t)*f[i] + t*ratio));
  }
  return out;
}

function autoLevels(f, w, h) {
  const n = w*h, BINS = 2048;
  const hist = new Uint32Array(BINS);
  for (let i=0; i<n; i++) hist[Math.min(BINS-1, Math.floor(f[i]*BINS))]++;
  const lo2=Math.floor(n*0.02), hi2=Math.floor(n*0.98);
  let sum=0, loV=0, hiV=1;
  for (let b=0; b<BINS; b++) {
    sum += hist[b];
    if (sum>=lo2 && loV===0) loV=b/BINS;
    if (sum>=hi2) { hiV=(b+1)/BINS; break; }
  }
  const range = Math.max(hiV-loV, 0.001);
  const out = new Float32Array(n);
  for (let i=0; i<n; i++) out[i] = Math.max(0, Math.min(1, (f[i]-loV)/range));
  return out;
}

function applyContrast(f, w, h, factor) {
  const out = new Float32Array(w*h);
  for (let i=0; i<w*h; i++) out[i] = Math.max(0, Math.min(1, 0.5+(f[i]-0.5)*factor));
  return out;
}

/* ── Local contrast enhancement ──────────────────────────────────────
   Computes the local mean in a neighbourhood sized to stroke width,
   then amplifies how far each pixel deviates from that mean.
   Effect: ink that's slightly gray relative to its surroundings gets
   pushed hard toward black; nearby paper gets pushed toward white.
   This is clearly visible across the full slider range with no halos,
   because the blur radius matches actual stroke scale (not sub-pixel). */
/* ── Sobel edge detection ────────────────────────────────────────────
   Kept for reference but no longer used in the sharpen pipeline. */

/* ── Separable box morphology ─────────────────────────────────────────
   Square SE, O(n·r) via row-then-column passes.
   0 = ink, 1 = paper.
   dilate: ink spreads  erode: paper spreads (shrinks ink) */
function morphBox(bin, w, h, r, op) {
  const target  = (op === 'dilate') ? 0 : 1;
  const neutral = 1 - target;
  const tmp = new Uint8Array(w * h);
  const out = new Uint8Array(w * h);
  for (let y = 0; y < h; y++) {
    for (let x = 0; x < w; x++) {
      let found = false;
      for (let dx = -r; dx <= r && !found; dx++) {
        const nx = x + dx;
        if (nx >= 0 && nx < w && bin[y*w+nx] === target) found = true;
      }
      tmp[y*w+x] = found ? target : neutral;
    }
  }
  for (let y = 0; y < h; y++) {
    for (let x = 0; x < w; x++) {
      let found = false;
      for (let dy = -r; dy <= r && !found; dy++) {
        const ny = y + dy;
        if (ny >= 0 && ny < h && tmp[ny*w+x] === target) found = true;
      }
      out[y*w+x] = found ? target : neutral;
    }
  }
  return out;
}

/* ── Sharpen: morphological opening + tighter anti-alias blur ─────────
   Opening = erode(r) → dilate(r):
     • Erode strips the fuzzy outer layer of pixels from every stroke edge
     • Dilate restores the stroke core to its original width
     • Net: same stroke thickness, but with a clean hard edge
       (the fuzzy gray boundary pixels were real noise, not real ink)
   Anti-alias blur scales down with amount so final edges are harder.
   At amount=1: blur sigma 0.85 → 0.25 (nearly crisp binary)

   This is the correct laser-style sharpening:
   "hard, clean, same-width strokes" — not "bolder strokes" */
function edgeSharpen(bin, gray, w, h, amount) {
  // Morphological opening (r=1): removes noise specks and
  // strips the one-pixel fuzzy boundary from every stroke
  const eroded  = morphBox(bin, w, h, 1, 'erode');
  const cleaned = morphBox(eroded, w, h, 1, 'dilate');

  const out = new Float32Array(w * h);
  for (let i = 0; i < w*h; i++) out[i] = cleaned[i];
  return out;
}

function mkCanvas(w,h) { const c=document.createElement('canvas'); c.width=w; c.height=h; return c; }

/* ═══════════════════════════════════════════════════════
   RASTER → JPEG DATA URL  (for embedding in SVG)
   ═══════════════════════════════════════════════════════ */
/* ═══════════════════════════════════════════════════════
   DOWNLOADS
   ═══════════════════════════════════════════════════════ */

// JPG: output at native processing resolution — highest possible quality.
$('btnJPG').addEventListener('click', () => {
  if (!rasterData) return;
  const { gray, w, h } = rasterData;
  const out = mkCanvas(w, h);
  const oxc = out.getContext('2d');
  const id  = oxc.createImageData(w, h);
  for (let i = 0; i < w*h; i++) {
    const v = Math.round(gray[i]*255);
    id.data[i*4]=id.data[i*4+1]=id.data[i*4+2]=v; id.data[i*4+3]=255;
  }
  oxc.putImageData(id, 0, 0);
  out.toBlob(blob => dl(blob, 'recipe.jpg'), 'image/jpeg', 1.0);
});

// Design SVG: standalone vector, no embedded image, no fixed size.
// User imports into laser software and sizes/positions as needed.
$('btnSVGdesign').addEventListener('click', () => {
  const svgStr = [
    '<?xml version="1.0" encoding="UTF-8"?>',
    '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 800 800">',
    `  <g>${getDesignInner()}</g>`,
    '</svg>'
  ].join('\n');
  const nameMap = { floral: 'FloralFooter', kitchen: 'KitchenFooter', grill: 'GrillFooter' };
  const filename = (nameMap[activeDesign] || activeDesign) + '.svg';
  dl(new Blob([svgStr], {type:'image/svg+xml;charset=utf-8'}), filename);
});

function dl(blob, filename) {
  const url=URL.createObjectURL(blob);
  const a=Object.assign(document.createElement('a'),{href:url,download:filename});
  document.body.appendChild(a); a.click(); document.body.removeChild(a);
  setTimeout(()=>URL.revokeObjectURL(url),2000);
}

/* ═══════════════════════════════════════════════════════
   RESET
   ═══════════════════════════════════════════════════════ */
$('btnReset').addEventListener('click', () => {
  sourceImg=rasterData=null; activeTab='original';
  eraserOn=false; eraseHistory=[]; isErasing=false;
  $('btnUndoErase').disabled=true; $('btnResetErase').disabled=true;
  updateEraserUI(); $('eraserBar').style.display='none';
  $('fileInput').value='';
  $('uzInner').innerHTML=`<span class="uz-icon">📷</span><div class="uz-text">Drop your photo here<br>or <strong>click to browse</strong></div><div class="uz-formats">JPG · JPEG · PNG · WEBP</div>`;
  $('statusStrip').className='status-strip';
  ['btnJPG','btnReset'].forEach(id=>$(id).disabled=true);
  $('tabDesign').disabled=true;
  $('btnSVGdesign').disabled=true;
  $('tabPreview').disabled=true;
  $('infoBar').classList.remove('show');
  $('designBottom').style.display='none';
  canvas.style.display='none'; $('phBlock').style.display='flex';
  document.querySelectorAll('.p-tab').forEach(b=>b.classList.toggle('active',b.dataset.tab==='original'));
});